'use strict';

var contains = require('./contains');

module.exports = contains;


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/some.js
// module id = 1715
// module chunks = 2